<template>
  <div class="card_box" :class="{minStyle:isMinStyle}" @click="goPathUrl('/shopDetail?id=' + itemObj.stock_id)" >
    <img class="card_img" :src="itemObj.goods_image" alt="" />
    <div class="goods_desc">
      <dl>
        <dt class="good_name">{{itemObj.goods_name}}</dt>
        <dd class="targ" v-if="itemObj.rank_text !=''  || (itemObj.new_products && itemObj.new_products.name !='') || itemObj.brand && itemObj.brand.name !='' || itemObj.type !='1' ">
			<span class="targ_i " :style="{background:colorList[itemObj.new_products.ptype-1] }" v-if="itemObj.new_products && itemObj.new_products.name !=''" > {{itemObj.new_products.name}}</span>
			<span class="targ_i bg_orange" v-if="itemObj.rank_text !='' ">{{itemObj.rank_text}}</span><span class="targ_i bg_black" v-if="itemObj.brand && itemObj.brand.name !='' ">{{itemObj.brand.name}}</span>
			<span class="targ_i targ_store" v-if="itemObj.type !='1'" >{{itemObj.type_name}}</span>
		</dd>
       <dd class="jifen" :style="{color:newMarkInfo.color}"> {{itemObj.jinbi}}<span>积分</span></dd>
		<dd class="num_gather flex_b">
          <div class="flex orange" v-if="itemObj.sales_text !=''" :style="{color:newMarkInfo.color}">
            <iconfont
              name="iconhuomiao"
              class="icon"
              size="0.4rem"
              :color="newMarkInfo.heat_color"
            ></iconfont>
            {{itemObj.sales_text}}
          </div>
		<!-- {{isMinStyle}}!isMinStyle && -->
          <b v-if="is_show_price==1">建议兑换:{{itemObj.retail_price}}</b>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
	import Iconfont from "@/components/iconfont.vue";
export default {
	components: {  Iconfont },
	props:{
		itemObj:{
			type:Object,
			default(){
				return{}
			}
		},
		isMinStyle:{
			type:[String,Number],
			default:0
		},
		is_show_price:{
			type:[String,Number],
			default:0
		},
		newMarkInfo: {
				type: Object,
				default () {
					return {}
				}
			},
	},
	data(){
		return{
			colorList:['#00B97C','#FF5736','#FFBE00','#F40923'],
			
		}
	},
	created(){
	
	},
	mounted(){

	},
	methods:{
		goPathUrl(e){
			 this.$router.push({
			          path: e,
			        });
		},
	}
	
};
</script>

<style  scoped>
	.card_img{
		width: 100%;
		height: 6.9rem;
		display: block;
		margin-bottom: 0.24rem;
		border-radius: 0.24rem  0.24rem 0 0  ; 
		border: 0 none;
	}
	.card_box{
		width: 6.9rem;
		background: #fff;
		border-radius: 0.32rem;
		padding-bottom: 0.48rem;
		margin-bottom: 0.4rem;
	}
	.goods_desc{
		margin: 0 0.48rem 0 0.4rem;
	}
	.card_box.minStyle .goods_desc{
		margin: 0 0.32rem;
	}
	.goods_desc dd{
		margin: 0;
	}
	.good_name{
		color: #333333;
		font-size: 0.54rem;
		/* height: 1.48rem; */
		line-height: 0.74rem;
		display: box;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	dd.targ{
		
	}
	.targ_i{
		vertical-align: bottom;
		color: #fff;
		font-size: 0.4rem;
		display: inline-block;
		margin-right: 0.1rem;
		/* height: 0.6rem; */
		/* line-height: 0.66rem; */
		padding: 0 0.09rem;
		border-radius: 0.12rem;
		border: 1px solid transparent;
	}
	.targ_i:last-child{
		margin-right:0;
	}
	.bg_green{
		background: #00B97C;
	}
	.bg_orange{
		background: #FF8904;
	}
	.targ_i.bg_black{
		background: #332A1F;
		color:#FFDCB1 ;
	}
	.num_gather{
		color: #999999;
		font-size: 0.4rem;
	}
	.num_gather  .icon{
		margin-top: 0.04rem;
	}
	.num_gather .orange{
		color: #FF463A;
		font-weight: 400;
		font-size: 0.4rem;
		align-items: center;
	}
	.targ_i.targ_store{
		background: #FFEBE6;
		border: 1px solid #FF5736 ;
		color: #FF5736;
	}
	.jifen{
		color: #F40923;
		font-size: 0.75rem;
		font-weight: bold;
		vertical-align: bottom;
		height: 0.75rem;
		line-height: 0.75rem;
		margin-top: 0.2rem  !important;
		margin-bottom: 0!important;
	}
	.jifen span{
		font-weight: normal;
		font-size: 0.48rem;
		display: inline-block;
		margin-left: 0.08rem ;
		vertical-align: bottom;
	}
	/* 兼容分类列表样式 */
	.card_box.minStyle{
		width: 5.4rem;
	}
	.card_box.minStyle .card_img{
		height: 5.4rem;
	}
	.card_box.minStyle .good_name{
		font-size: 0.48rem;
		line-height: 0.6rem;
		height: 1.2rem;
		margin-bottom:0.1rem;
		
	/* 	margin-left: 0.46rem; */
	}
	.del_text{
		text-decoration: line-through;
		}

</style>